import { MemberType } from "../../Enums/PersonEnums";
import { normalizeRoleToKey } from "../../Enums/UserEnums";
import { isWorldServicesGroupFirmId } from "../../utils/wsgStaffFirms";

export const STAFF_PROFILES_LABEL = "Staff Profiles";
export const WSG_ENTITY_BUTTON_LABEL = "WSG Profile";

export function isWsgStaffProfilesFirm(firmId?: string | null): boolean {
  return isWorldServicesGroupFirmId(firmId);
}

export function formatWsgStaffRoleLabel(role?: string | null): string {
  const key = normalizeRoleToKey(role);
  if (key === "wsgSuper") {
    return "Super Staff";
  }
  if (key === "wsgStaff") {
    return "Staff";
  }
  return "";
}

export function formatWsgStaffStatusLabel(person: {
  isDeleted?: boolean;
} | null | undefined): string {
  if (person?.isDeleted) {
    return "Disabled";
  }
  return "Active";
}

/** Staff and Super Staff profiles omit Areas of Practice until Practicing attorney is on. */
export function shouldShowAreasOfPractice(input: {
  firmId?: string | null;
  routeFirmId?: string | null;
  parentFirmId?: string | null;
  isAttorney?: boolean;
  memberType?: number;
}): boolean {
  const staffProfiles =
    isWsgStaffProfilesFirm(input.routeFirmId) ||
    isWsgStaffProfilesFirm(input.firmId) ||
    isWsgStaffProfilesFirm(input.parentFirmId);
  if (staffProfiles) {
    return Boolean(input.isAttorney);
  }
  return Boolean(input.isAttorney) || input.memberType === MemberType.member;
}
